export default "__VITE_ASSET__Bki$snz6__"